<script setup lang="ts">
import {MAP_DISPLAY_PARAMS_LABELS, MapDisplayParamsKey} from "@/composables/constants/params";

interface MapLegendProps {
  paramName: MapDisplayParamsKey;
}

defineProps<MapLegendProps>();
</script>

<template>
  <div class="map-legend">
    <span class="map-legend__title">
      {{ MAP_DISPLAY_PARAMS_LABELS[paramName] }}
    </span>
    <div class="map-legend__list">
      <div class="map-legend__item">
        <div class="map-legend__square map-legend__square--green" />
        Отрицательная динамика к АППГ
      </div>
      <div class="map-legend__item">
        <div class="map-legend__square map-legend__square--red" />
        Положительная динамика к АППГ
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.map-legend {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: var(--background-bg-white);
  box-shadow: 1px 2px 10px 0 var(--gray-gray50);
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-width: 304px;
  z-index: 9;

  &__square {
    width: 16px;
    height: 16px;
    border-radius: 4px;

    &--green {
      background-color: var(--oracul-green-green20);
    }

    &--red {
      background-color: var(--oracul-red-red20);
    }
  }

  &__title {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: var(--black-black100);
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
  }
}
</style>